import React from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";

import tradelicense from "../images/AT INDIA PACKER & MOVERS Trande Licence_page-0001.jpg";
import gst from "../images/GST CERTI_page-0001.jpg";
import ptax from "../images/Profession Tax at india_page-0001.jpg";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

function Certicficate() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="Gray" />
            <div className='packermovershoogle'>
                <div className="album py-1">

                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">About Us</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br />
            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <Zoom>
                                <img src={tradelicense} className="card-img-top" alt="tradelicense" />
                            </Zoom>
                        </div>
                        <div className="col-md-4 mt-3">
                            <Zoom>
                                <img src={gst} className="card-img-top" alt="gst" />
                            </Zoom>

                        </div>
                        <div className="col-md-4 mt-3">
                            <Zoom>
                                <img src={ptax} className="card-img-top" alt="ptax" />
                            </Zoom>

                        </div>

                    </div>
                </div>
            </div>
            <br />
            <br />

        </div>
    )
}

export default Certicficate